import {
  UserProfileDeletePudDocument,
  UserProfileDeletePudMutationVariables,
} from "@graphql/api";

export default async function userProfileDeletePud(
  locationId: number,
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileDeletePudMutationVariables = {
    locationId,
  };
  const result = await client.mutate({
    mutation: UserProfileDeletePudDocument,
    variables: mutVars,
  });

  if (result.data?.userProfileDeletePud.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.userProfileDeletePud.success ?? false;
}
